<template>
  <el-scrollbar
    v-loading="loading"
    wrap-class="scrollbar-wrapper"
    :style="`background-color: ${theme.slideColor}`"
  >
    <!-- :default-active="defaultActive" -->
    <el-menu
      ref="menu"
      :class="{ slideNavBar: isSlide }"
      :show-timeout="200"
      :collapse="isCollapse"
      :collapse-transition="false"
      mode="vertical"
      :background-color="theme.slideColor"
      :text-color="theme.textColor"
      :active-text-color="theme.slideActiveColor"
      @select="navSelect"
      @open="open"
    >
      <el-menu-item class="filterItem" index="filter">
        <el-input
          ref="filterInput"
          :class="{ 'is-focus': showSearch }"
          :style="{ color: theme.textColor }"
          placeholder="请输入关键字"
          v-model="filter"
          clearable
          @blur="showSearch = false"
        >
          <i-switch
            :style="{
              'background-color':
                theme.value === 'default'
                  ? theme.slideColor
                  : theme.value === 'custom'
                  ? theme.headerColor
                  : theme.textColor,
            }"
            v-model="isSlide"
            slot="prepend"
            v-if="!showSearch"
          >
            <svg-icon icon-class="dropdown" slot="close" />
            <svg-icon icon-class="slide" slot="open" />
          </i-switch>
          <el-button slot="append" @click="handleFilter">
            <i :style="{ color: theme.textColor }" class="el-icon-search"></i>
          </el-button>
        </el-input>
      </el-menu-item>
      <el-menu-item
        v-show="false"
        index="/"
        class="submenu-title-noDropdown"
        @click.native="itemClick"
      >
        <item icon="example" title="首页" />
      </el-menu-item>
      <sidebar-item
        :filter="filter"
        @nodeClick="nodeClick"
        :style="`background-color:${theme.slideColor}`"
        v-for="template in templateTreeFilter"
        :key="template.id"
        :item="template"
        :isCollapse="isCollapse"
        @filterNodeOpen="filterNodeOpen"
        @handleStartWrokFlow="handleStartWrokFlow"
        @handleCreate="handleCreate"
        @mouseover="mouseover"
        @mouseleave="mouseleave"
      />
    </el-menu>
    <!-- 发起流程  -->
    <el-dialog
      id="launch-workflow"
      key="launch-workflow"
      append-to-body
      v-el-drag-dialog
      title="发起流程"
      :visible.sync="startVisible"
      width="350px"
    >
      <el-scrollbar>
        <div style="height: 400px" v-loading="startloading">
          <el-alert
            :title="$t('workflow.hasWorkflow')"
            type="success"
            :closable="false"
            style="margin-bottom: 10px"
          >
          </el-alert>
          <el-tree
            class="wfTree"
            highlight-current
            :indent="16"
            :data="currentWorkFlowList"
            :props="defaultProps"
            :default-expand-all="true"
            @node-click="handleCreateWorkFlow"
          >
          </el-tree>
        </div>
      </el-scrollbar>
    </el-dialog>
  </el-scrollbar>
</template>

<script>
import { getTemplateAttribute } from '@/api/preview'
import Cookies from 'js-cookie'
import Item from './Item'
import { mapGetters } from 'vuex'
import SidebarItem from './SidebarItem'
import { getTemplateCategorys } from '@/api/login'
import { getWorkFlowTargets } from '@/api/workFlow'
export default {
  components: { SidebarItem, Item },
  data() {
    return {
      currentWorkFlowList: [],
      openList: [],
      isSlide: false,
      showSearch: false,
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      targetList: [],
      workFlowListInit: false,
      startloading: false,
      startVisible: false,
      filtering: false,
      filterDefaultActive: '',
      templateTreeFilter: [],
      loading: false,
      templateTree: [],
      filter: ''
    }
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'backgroundColor',
      'textColor',
      'activeTextColor',
      'logoBackgroundColor',
      'theme',
      'disableTree'
    ]),
    isCollapse() {
      return !this.sidebar.opened
    },
    defaultActive() {
      if (this.$route.path === '/dashboard' || this.$route.path === '/setting') {
        return '/'
      } else {
        return this.$route.params.templateId
      }
    }

  },
  watch: {
    isSlide(newVal) {
      Cookies.set('isSlide', newVal)
      if (newVal) {
        this.openList.forEach(o => {
          this.$refs.menu.close(o)
        })
      }
    }
  },
  created() {
    this.fetchTemplateCategorys()
    // eslint-disable-next-line no-eval
    this.isSlide = Cookies.get('isSlide') ? eval(Cookies.get('isSlide').toLowerCase()) || false : false
  },
  methods: {
    open(index) {
      if (this.openList.indexOf(index) === -1) {
        this.openList.push(index)
      }
    },
    mouseleave(id) {
      if (this.isSlide) {
        this.$refs.menu.close(id)
      }
    },
    mouseover(id) {
      if (this.isSlide) {
        this.$refs.menu.open(id)
      }
    },
    handleFilter() {
      this.showSearch = !this.showSearch
    },
    filterNodeOpen(id) {
      this.$refs.menu.open(id.toString())
      console.log(id)
    },
    filterClear() {
      this.templateTreeFilter = JSON.parse(JSON.stringify(this.templateTree))
    },
    // 搜索
    filterChange(val) {
      this.templateTreeFilter = this.templateTreeFilter.filter(t => {
        console.log(t)
        t.name.indexOf(val) !== -1
      })
    },
    // 点击节点
    nodeClick(node) {
      if (this.disableTree) {
        this.$message.error('请等待当前页面加载完毕！')
        return
      }
      const nodeClone = JSON.parse(JSON.stringify(node))
      console.log(nodeClone)
      switch (node.type) {
        case 1:
          nodeClone.routeType = nodeClone.type === 0 ? 'create' : 'query'
          nodeClone.nodeId = `create-${nodeClone.id}`
          nodeClone.templateId = nodeClone.id
          nodeClone.name = nodeClone.name + (nodeClone.type === 0 ? `-${this.$t('buttons.create')}` : '')
          nodeClone.path = `/report/${nodeClone.id}/0`
          this.$router.push(nodeClone.path)
          this.$store.dispatch('SetLastTab', nodeClone)
          this.$store.dispatch('addView', nodeClone)
          break
        case 0:
        case 2:
          nodeClone.routeType = 'preview'
          nodeClone.templateId = nodeClone.id
          nodeClone.nodeId = `preview-${nodeClone.id}`
          nodeClone.name = `${nodeClone.name}-${this.$t('buttons.history')}`
          nodeClone.path = `/${nodeClone.routeType}/${nodeClone.id}/${nodeClone.type}`
          this.$router.push(nodeClone.path)
          this.$store.dispatch('SetLastTab', nodeClone)
          this.$store.dispatch('addView', nodeClone)
          break
        case 5:
          this.$store.dispatch('openDecision', {
            decisionId: nodeClone.strategyId,
            decisionName: nodeClone.name,
            vm: this
          })
          break
      }
    },
    // 新建表单
    handleCreate(node) {
      if (this.disableTree) {
        this.$message.error('请等待当前页面加载完毕！')
        setTimeout(() => {
          this.$store.dispatch('setDisableTree', false)
        }, 5000)
        return
      } else {
        this.$store.dispatch('setDisableTree', true)
      }
      getTemplateAttribute(node.id).then(response => {
        const addMode = response.data.addMode
        const dataRow = {
          templateId: node.id,
          recordId: 0
        }
        const reportTitle = `${node.name}-${this.$t('buttons.create')}`
        if (addMode === 1 || addMode === 2) {
          this.$emit('handleConnect', dataRow, 0, undefined, reportTitle, addMode, response.data.mutableNames)
        } else {
          const nodeClone = JSON.parse(JSON.stringify(node))
          nodeClone.routeType = nodeClone.type === 0 ? 'create' : 'query'
          nodeClone.nodeId = `create-${nodeClone.id}`
          nodeClone.templateId = nodeClone.id
          nodeClone.model = 0
          const url = `/report/${nodeClone.id}/0`
          // const url = nodeClone.type === 0 ? `/report/${nodeClone.id}/0` : ''
          nodeClone.name = nodeClone.name + (nodeClone.type === 0 ? `-${this.$t('buttons.create')}` : '')
          nodeClone.path = url
          // this.$router.push(url)
          // this.$store.dispatch('SetLastTab', nodeClone)
          this.$store.dispatch('addView', nodeClone)
          this.$bus.$emit('createFn', nodeClone)
        }
      })
    },
    // 打开新建流程tab
    handleStartWrokFlow(clickItemInfo) {
      getWorkFlowTargets(this.$store.getters.userId, clickItemInfo.id).then(res => {
        this.currentWorkFlowList = res.data
        if (this.currentWorkFlowList.length === 1) {
          const routerTemp = {
            name: `${this.currentWorkFlowList[0].name}-${this.$t('buttons.start')}`,
            nodeId: `createWorkFlow-${clickItemInfo.id}`,
            templateId: clickItemInfo.id,
            routeType: 'createWorkFlow',
            model: 0,
            path: `/workFlow/${clickItemInfo.id}/${this.currentWorkFlowList[0].id}/0`
          }
          this.startVisible = false
          this.$router.push(routerTemp.path)
          this.$store.dispatch('SetLastTab', routerTemp)
          this.$store.dispatch('addView', routerTemp)
        } else {
          this.startVisible = true
        }
      })
    },
    handleCreateWorkFlow(data) {
      if (data.nodeType !== 'category') {
        this.$store.dispatch('setDisableTree', true)
        const routerTemp = {
          name: `${data.name}-${this.$t('buttons.start')}`,
          nodeId: `createWorkFlow-${data.templateId}`,
          templateId: data.templateId,
          routeType: 'createWorkFlow',
          model: 0,
          path: `/workFlow/${data.templateId}/${data.id}/0`
        }
        this.$router.push(routerTemp.path)
        this.$store.dispatch('SetLastTab', routerTemp)
        this.$store.dispatch('addView', routerTemp)
        this.startVisible = false
      }
    },
    startWrokFlow() {
      this.startVisible = true
    },
    itemClick() {
      this.$router.push('/')
    },
    navSelect(index, indexPath) {
      // console.log(index, indexPath)
    },
    fetchTemplateCategorys() {
      this.loading = true
      getTemplateCategorys(this.$store.getters.userId).then(response => {
        this.templateTree = response.data
        this.templateTreeFilter = response.data
        // this.$nextTick(()=>{
        //   if (response.data.length) {
        //     this.$refs.menu.open(+response.data[0].id.toString())
        //   }
        // })
        this.loading = false
      })
    },
    findTemplateWorkFlow(treeNode) {
      if (treeNode.nodeType === 'template') {
        var workFlowInfo = this.targetList.filter(item => { return item.templateId === treeNode.id })
        if (workFlowInfo.length) {
          treeNode.workFlowInfo = workFlowInfo
        } else {
          treeNode.workFlowInfo = undefined
        }
      } else {
        if (treeNode.children) {
          treeNode.children.forEach(node => {
            this.findTemplateWorkFlow(node)
          })
        }
      }
    }
  }
}
</script>
<style lang="scss">
.hideSidebar .filterItem {
  display: none !important;
}
.mobile {
  .filterItem {
    width: 250px;
  }
}
.default {
  .filterItem {
    border-bottom: none;
    border-right: none;
  }
}
.custom {
  .filterItem {
    border-bottom: none;
    border-right: none;
  }
}
.filterItem {
  height: 38px !important;
  padding: 0 20px !important;
  line-height: 38px !important;
  // position: fixed !important;
  // left: 0;
  // top: 49px;
  width: 100%;
  z-index: 999;
  border-bottom: 1px solid #ebeef5;
  // border-right:1px solid #ebeef5;
  .el-icon-search {
    color: #fff;
  }
  .el-input {
    overflow: hidden;
  }
  .el-input__suffix {
    right: 15px;
  }
  .el-input.is-focus .el-input__inner {
    transform: translateX(0) !important;
  }
  .el-input__inner {
    border: none;
    border-bottom: 1px solid #b3b3b3;
    background: transparent;
    border-radius: 0;
    color: inherit;
    transform: translateX(110%);
    transition: 0.3s;
  }
  .el-input-group__append,
  .el-input-group__prepend {
    background: transparent;
    border: none;
    padding: 1px;
    margin-top: -3px;
  }
  .el-input-group__append .el-button {
    padding: 0;
  }
  .el-icon-search {
    margin-right: 0;
  }
  .el-radio-button__inner {
    padding: 2px 8px;
    margin: 0;
    background: transparent;
  }
  .el-radio-button:first-child .el-radio-button__inner {
    border-top-left-radius: 50px;
    border-bottom-left-radius: 50px;
    color: #fff;
  }
  .el-radio-button:last-child .el-radio-button__inner {
    border-top-right-radius: 50px;
    border-bottom-right-radius: 50px;
    color: #fff;
  }
  .svg-icon {
    margin: 0 !important;
    width: 14px !important;
    height: 14px !important;
  }
}
.logoItem {
  padding: 0 !important;
  height: 49px;
}
.scrollbar-wrapper .logo {
  width: 270px;
  height: 100%;
  float: left;
  a.img {
    display: block;
    width: 100%;
    height: 100%;
    position: relative;
    top: -5px;
    overflow: hidden;
  }
}
.sidebar-container {
  transition: background-color 0.3s;
}
#app .sidebar-container .slideNavBar {
  transition: 0.3s;
  position: relative;
  .el-submenu__icon-arrow {
    transform: rotateZ(-90deg);
  }
  .el-menu--inline {
    position: fixed;
    left: 260px;
    top: 49px;
    width: 270px !important;
    overflow: hidden;
    z-index: 999;
    .el-menu-item {
      background: transparent !important;
      background-color: transparent !important;
    }
    .el-menu--inline {
      left: 520px;
      .el-menu--inline {
        left: 780px;
      }
    }
    .el-submenu__title {
      background: transparent !important;
      background-color: transparent !important;
    }
  }
}
</style>
